import { createSelector } from 'reselect';

import { businessSelectors } from 'app-components/flux/business';
import { createWeakMapSelector } from 'app-components/utils/core/reselect';
import type RootState from 'app-components/utils/redux-store/rootState';

import { TERMS_REDUCER_KEY } from './termsTypes';

type State = Pick<RootState, typeof TERMS_REDUCER_KEY>;

export const getTermsStore = (state: State) => state[TERMS_REDUCER_KEY];
export const getResourcesById = (state: State) => getTermsStore(state).resourcesById;
export const getLoadPending = (state: State) => getTermsStore(state).loadPending;
export const getIsLoading = (state: State) => getTermsStore(state).isLoading;
export const getError = (state: State) => getTermsStore(state).error;
export const getLastSyncDate = (state: State) => getTermsStore(state).lastSyncDate;

export const getTerms = createSelector(getResourcesById, (terms) =>
  terms?.filter((t) => !t.isArchived && !t.isDeleted),
);

export const getTermsList = createSelector(getTerms, (terms) => terms?.toList());

export const getDefaultTermForBusiness = createWeakMapSelector(
  [getTerms, businessSelectors.getBusinessForId],
  (terms, business) => {
    if (!terms) {
      return undefined;
    }

    const defaultTermId = business?.defaultTermId;
    if (defaultTermId) {
      const defaultTerm = terms.get(defaultTermId);
      if (defaultTerm) {
        return defaultTerm;
      }
    }

    const thirtyDayTerms = terms.filter((term) => term.days === 30);
    if (thirtyDayTerms.size === 0) {
      return undefined;
    }

    return thirtyDayTerms.minBy((term) => `${term.id ?? term.clientId ?? term.name ?? ''}`);
  },
);
